"use client";

import Autoplay from "embla-carousel-autoplay";
import React from "react";
import type { CarouselContent, CarouselProps } from "./carousel";
import { Carousel } from "./carousel";
import { cn } from "./lib/utils";

type AutoplayCarouselProps = React.HTMLAttributes<HTMLDivElement> &
  CarouselProps & {
    delay?: number;
    isDefaultOpts?: boolean;
    children:
      | React.ReactElement<typeof CarouselContent>
      | React.ReactElement<typeof CarouselContent>[];
  };

export function AutoplayCarousel({
  delay = 5000,
  children,
  className,
  isDefaultOpts = false,
  opts,
  ...props
}: AutoplayCarouselProps) {
  const plugin = React.useRef(
    Autoplay({ delay, stopOnInteraction: true, jump: false }),
  );

  return (
    <Carousel
      {...props}
      plugins={[plugin.current]}
      onMouseEnter={plugin.current.stop}
      onMouseLeave={() => plugin.current.play(false)}
      className={cn("h-full w-full", className)}
      opts={
        isDefaultOpts
          ? {
              loop: true,
              duration: 70,
              containScroll: "trimSnaps",
              dragFree: false,
            }
          : opts
      }
    >
      {children}
    </Carousel>
  );
}
